module.exports = __webpack_public_path__ + "static/media/draussen_loesung.4a67ccbe.jpg";